import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { IReadingLevel } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-add-reading-batch-level',
  templateUrl: './add-reading-batch-level.component.html',
  styleUrls: ['./add-reading-batch-level.component.scss']
})
export class AddReadingBatchLevelComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  TITLE = `Add new batch level`
  form: FormGroup;
  book: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<AddReadingBatchLevelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }


  ngOnInit() {
    this.form = this.fb.group({
      order: [null, Validators.required],
      name: [null, Validators.required],
    })
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { ITEM } = this.data;
      const { user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { name, order } = f;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: IReadingLevel = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: null,
        organizationRef: null,
        organizationKey: null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name, order
      }

      this.store.addNewItem(COLLECTION_NAME.READING_BATCH_LEVEL, item, (success, res) => {
        if (success) {
          this.snackBar.open(`Level has been created successful.`, "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close('yes');
        }
      })
    }
  }
}
